var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 76,
    viewBox: "0 0 279 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.129 75.8204L160.505 54.6972H159.635H144.372V75.8204H126.82V0H159.635C166.351 0 172.187 1.11529 177.133 3.3651C182.08 5.60048 185.883 8.77329 188.551 12.8883C191.223 17.0034 192.555 21.8827 192.555 27.5121C192.555 33.1414 191.204 37.9919 188.493 42.0781C185.796 46.1547 181.95 49.2746 176.965 51.4379L193.973 75.8156H175.129V75.8204ZM174.802 27.5121C174.802 23.248 173.427 19.9742 170.687 17.7148C167.947 15.441 163.942 14.2968 158.669 14.2968H144.372V40.7321H158.669C163.942 40.7321 167.947 39.5735 170.687 37.2564C173.427 34.9537 174.802 31.6944 174.802 27.5121Z",
    fill: "#7C57FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253.868 59.5622H218.669L211.953 75.8204H193.979L227.759 0H245.094L279 75.8204H260.588L253.868 59.5622ZM236.316 17.2245L224.298 46.2508H248.349L236.316 17.2245Z",
    fill: "#7C57FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2527 14.2968H0V0H74.4552L66.0616 14.2968H41.8041V75.8204H24.2527V14.2968Z",
    fill: "#7C57FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8047 75.8204H81.3205L61.2357 41.0301L41.8047 75.8204ZM101.588 75.8204H126.826L84.1616 0L71.2012 23.1951L101.588 75.8204Z",
    fill: "#7C57FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ec2d15f6d6f2b9a9bae1abd4e766ea3e.svg";
export { ForwardRef as ReactComponent };